import React from 'react'
import StructuredData from './StructuredData'

export const getThingData = ({ name }) => {
  return {
    '@type': 'Thing',
    name,
  }
}

export default function ThingStructuredData({ data }) {
  if (!data || Object.keys(data).length === 0) return null
  const structuredData = getThingData(data)

  return <StructuredData data={structuredData} dataTestId="thing-structured-data" />
}
